export const TrelloLogoBrand = () => (
    <svg
        width="163"
        height="48"
        viewBox="0 0 163 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.735 6.03613H3.877C1.736 6.03613 0 7.77213 0 9.91313V34.7711C0 36.9121 1.736 38.6481 3.877 38.6481H28.735C30.876 38.6481 32.612 36.9121 32.612 34.7711V9.91313C32.612 7.77213 30.876 6.03613 28.735 6.03613ZM14.048 29.5251C14.048 30.2371 13.471 30.8131 12.76 30.8131H7.309C6.597 30.8131 6.021 30.2361 6.021 29.5251V13.3451C6.021 12.6331 6.598 12.0571 7.309 12.0571H12.76C13.472 12.0571 14.048 12.6341 14.048 13.3451V29.5251ZM26.591 22.0971C26.591 22.8091 26.014 23.3851 25.303 23.3851H19.852C19.14 23.3851 18.564 22.8081 18.564 22.0971V13.3451C18.564 12.6331 19.141 12.0571 19.852 12.0571H25.303C26.015 12.0571 26.591 12.6341 26.591 13.3451V22.0971Z"
            fill="url(#paint0_linear_818_506)"
        />
        <path
            d="M67.588 8.42822V14.7292H60.117V38.6482H52.917V14.7292H45.447V8.42822H67.588Z"
            fill="#172B4D"
        />
        <path
            d="M76.759 38.6483H70.099V15.1443H76.759V19.6503C78.019 16.4763 80.044 14.5913 83.645 14.8223V21.7673C78.965 21.3983 76.759 22.5493 76.759 26.3203V38.6473V38.6483Z"
            fill="#172B4D"
        />
        <path
            d="M120.029 38.8311C115.664 38.8311 112.918 36.7161 112.918 31.7941V6.03613H119.623V30.8741C119.623 32.3001 120.568 32.8071 121.739 32.8071C122.098 32.8071 122.324 32.8071 122.729 32.7601V38.5561C122.369 38.6941 121.379 38.8311 120.029 38.8311Z"
            fill="#172B4D"
        />
        <path
            d="M134.025 38.8311C129.66 38.8311 126.914 36.7161 126.914 31.7941V6.03613H133.619V30.8741C133.619 32.3001 134.564 32.8071 135.735 32.8071C136.094 32.8071 136.32 32.8071 136.725 32.7601V38.5561C136.365 38.6941 135.375 38.8311 134.025 38.8311Z"
            fill="#172B4D"
        />
        <path
            d="M139.93 26.8732C139.93 19.6062 144.115 14.6372 151.316 14.6372C158.471 14.6372 162.612 19.6062 162.612 26.8732C162.612 34.0952 158.471 39.2002 151.316 39.2002C144.116 39.2002 139.93 34.0952 139.93 26.8732ZM146.456 26.8732C146.456 30.4162 147.941 33.2212 151.316 33.2212C154.646 33.2212 156.086 30.4162 156.086 26.8732C156.086 23.3302 154.646 20.6172 151.316 20.6172C147.941 20.6172 146.456 23.3312 146.456 26.8732Z"
            fill="#172B4D"
        />
        <path
            d="M92.635 29.0112C93.911 29.1492 96.082 29.3422 98.252 29.3422C103.352 29.3422 107.66 27.9712 107.66 23.0342C107.66 18.2402 103.233 14.6372 97.904 14.6372C90.733 14.6372 86.142 19.8362 86.142 27.1032C86.142 34.6472 90.103 39.1082 99.058 39.1082C101.803 39.1082 104.773 38.6012 106.843 37.7272V32.0932C104.546 32.8282 101.955 33.5602 99.3 33.5602C95.725 33.5602 93.255 32.3872 92.636 29.0122L92.635 29.0112ZM97.771 19.7712C99.658 19.7712 101.175 21.0482 101.175 22.8022C101.175 25.0572 98.794 25.7622 96.057 25.7622C94.682 25.7622 93.422 25.6152 92.575 25.4852C92.708 24.3212 92.994 23.2052 93.498 22.3692C94.44 20.8092 95.9 19.7712 97.771 19.7712Z"
            fill="#172B4D"
        />
        <defs>
            <linearGradient
                id="paint0_linear_818_506"
                x1="16.306"
                y1="38.6481"
                x2="16.306"
                y2="6.03613"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0055CC" />
                <stop offset="1" stopColor="#1D7AFC" />
            </linearGradient>
        </defs>
    </svg>
);
